export interface AuraChatMock {
    question: string;
    answer: string;
}

export const auraChatMocks: AuraChatMock[] = [
    {
        question: 'Quais contatos devo priorizar hoje?',
        answer: `Recomendo priorizar os contatos em risco e com alertas de atenção:

            - Ricardo Sampaio (Loggix Transportes): score 22 (Em risco) e sentimento Irritado.
            - Tiago Ferreira (Orion Energia): score 58 (Atenção) e sentimento Insatisfeito.
            - Eduardo Nakamura (Fintrust Capital): score 59 (Atenção) e sentimento Insatisfeito.
            - Maria Faro (Mobcall): score 60 (Atenção) e sem nenhuma interação até o momento.`,
    },
    {
        question: 'Quem está em risco na carteira?',
        answer: `O contato atualmente classificado em risco na carteira é:

            - Ricardo Sampaio (Loggix Transportes): score 22 (Em risco), último sentimento Irritado, última interação em 25/08/2026, sob responsabilidade de Camila Reis.`,
    },
    {
        question: 'Resuma a saúde geral da carteira.',
        answer: `A carteira possui 7 contatos distribuídos nos seguintes status:

            - Saudável: 3 contatos (Sofia Albuquerque, Marina Duarte e Juliana Prado)
            - Atenção: 3 contatos (Maria Faro, Eduardo Nakamura e Tiago Ferreira)
            - Em risco: 1 contato (Ricardo Sampaio)
            No momento, a maior parte da carteira está dividida entre status saudável e atenção, havendo apenas um cliente em situação crítica de risco.`,
    },
];
